import React, { useState } from "react";
import { InitialAuditionStateType } from "../../assets/data/initialState";
import { FormikType } from "../../types/types";
import { CustomButton, LinkToCompanyModal } from "../Components";

export type Props = FormikType<InitialAuditionStateType>;

export default function LinkToCompany({ formik }: Props) {
  const [isLinkToCompanyModalVisible, setIsLinkToCompanyModalVisible] =
    useState<boolean>(false);

  return (
    <div className="mb-8">
      <LinkToCompanyModal
        formik={formik}
        isOpen={isLinkToCompanyModalVisible}
        closeModal={() => setIsLinkToCompanyModalVisible(false)}
      />
      <p className="font-Switzer font-bold text-2xl tracking-tight mb-1">
        Link To Company
      </p>
      <p className="font-Switzer text-base tracking-tight mb-2">
        Choose a Company to whom you want to link this audition. On Industry
        Auditions, users will be able to see all linked companies.
      </p>
      <div className="flex flex-row space-x-2">
        <CustomButton
          text="Edit"
          className="medium-green-button"
          onClick={() => setIsLinkToCompanyModalVisible(true)}
        />

        {formik.values.company ? (
          <CustomButton
            text={formik.values.company.name}
            className="medium-white-button-no-hover"
          />
        ) : null}
      </div>
    </div>
  );
}
